/* Inner pages share the native details navigation with the film landing page. */
(() => {
  const menu = document.querySelector('.motion-menu');
  if (!menu || document.querySelector('[data-motion-home], [data-film-story]')) return;
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => { menu.open = false; });
  });
})();
